import axios from "axios";
export const state = {
    cashout: [],
    cashin: [],
    save_status: false,
};
export const getters = {
    CashIn: state => state.cashin.data,
    CashOut: state => state.cashout.data,
    SaveStatus: state => state.save_status,

};

export const mutations = {
    SET_CASHIN(state, newValue) {
        state.cashin = newValue
    },
    SET_CASHOUT(state, newValue) {
        state.cashout = newValue
    },
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },

};

export const actions = {
    // add Cashin
    recordCashin({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('cashin', payload).then(() => {
            dispatch('fetchCashin');
            let message = { 'msg': "Cash in record added successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Cash in record" }
            dispatch('notification/error', message, { root: true })

        })
    },


    // Edit Cashin
    editCashin({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`cashin/${payload.id}`, payload).then(() => {
            dispatch('fetchCashin');
            let message = { 'msg': "Cash in record updated successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Cash in record" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete expense 
    deleteCashin({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`cashin/${payload.id}`).then(() => {
            dispatch('fetchCashin');
            let message = { 'msg': "Cash in deleted successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Deleting Cash in" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // add Cashout
    recordCashout({ commit, dispatch }, payload) {
        // console.log(payload);
        commit('SET_SAVE_STATUS', true);
        axios.post('cashout', payload).then(() => {
            dispatch('fetchCashout');
            let message = { 'msg': "Cash out record added successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Cash out record" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit Cashout
    editCashout({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`cashout/${payload.id}`, payload).then(() => {
            dispatch('fetchCashout');
            let message = { 'msg': "Cash out record updated successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Cash out record" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete expense 
    deleteCashout({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`cashout/${payload.id}`).then(() => {
            dispatch('fetchCashout');
            let message = { 'msg': "Cash out deleted successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Deleting Cash out" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchCashin({ commit, dispatch }) {
        axios.get('cashin').then(res => {
            commit('SET_CASHIN', res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    fetchCashout({ commit, dispatch }) {
        axios.get('cashout').then(res => {
            commit('SET_CASHOUT', res.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },

};